import { render } from "./UpdateUserModal.vue?vue&type=template&id=1ab062fd"
import script from "./UpdateUserModal.vue?vue&type=script&lang=js"
export * from "./UpdateUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__